import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.splice";
import { SnackType } from '@/interfaces/snack';

var state = function state() {
  return {
    snacks: [],
    ifNewOrders: {
      order: false,
      refund: false,
      refundAudit: false,
      refundApplication: false
    }
  };
};

var mutations = {
  INSERT_MSG: function INSERT_MSG(state, msg) {
    state.snacks.push(msg);
  },
  REMOVE_MSG: function REMOVE_MSG(state, resIndex) {
    var leftSnacks = state.snacks.concat();
    leftSnacks.splice(resIndex, 1);
    state.snacks = leftSnacks;
  },
  UPDATE_IF_NEW_ORDERS: function UPDATE_IF_NEW_ORDERS(state, obj) {
    state.ifNewOrders = Object.assign({}, state.ifNewOrders, obj);
  }
};
var actions = {
  showSnack: function showSnack(context, msg) {
    var duration = 2000;

    switch (msg.type) {
      case SnackType.Error:
        duration = 2000;
        break;

      case SnackType.Success:
      default:
        duration = 1000;
        break;
    }

    context.commit('INSERT_MSG', msg);
    setTimeout(function () {
      context.commit('REMOVE_MSG', 0);
    }, duration);
  },
  updateIfNewOrders: function updateIfNewOrders(context, obj) {
    context.commit('UPDATE_IF_NEW_ORDERS', obj);
  }
};
export default {
  namespaced: true,
  state: state,
  actions: actions,
  mutations: mutations
};